/**
 * Cookie Consent Banner
 * Simple GDPR/PECR compliant cookie consent banner
 */

import { useState, useEffect } from 'react';

const COOKIE_CONSENT_KEY = 'cookie-consent';

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  function accept() {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in">
      <div className="max-w-4xl mx-auto bg-surface-dark border border-accent-silver/20 rounded-xl p-4 sm:p-6 shadow-2xl backdrop-blur-sm">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <p className="text-sm text-accent-silver flex-1">
            We use cookies to improve your experience and analyse site traffic.
            See our{' '}
            <a
              href="/cookies"
              className="text-brand-orange hover:underline font-medium"
            >
              Cookie Policy
            </a>{' '}
            for details.
          </p>
          <div className="flex gap-3 shrink-0">
            <button
              onClick={decline}
              className="px-4 py-2 text-sm font-medium text-accent-silver hover:text-accent-white border border-accent-silver/30 hover:border-accent-silver/50 rounded-lg transition-colors"
            >
              Decline
            </button>
            <button
              onClick={accept}
              className="px-4 py-2 text-sm font-medium text-white bg-brand-orange hover:bg-brand-orange-light rounded-lg transition-colors"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
